<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header">
        <h3 class="page-title">{{ $t('funders.basic_info') }}</h3>
      </div>
      <div class="row">
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.display_name') }}</label>
          <p v-if="viewFunder && viewFunder.name !=null">{{ viewFunder.name }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.primary_contact_name') }}</label>
          <p v-if="viewFunder && viewFunder.contact_name !=null">{{ viewFunder.contact_name }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.email') }}</label>
          <p v-if="viewFunder && viewFunder.email !=null">{{ viewFunder.email }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.phone') }}</label>
          <p v-if="viewFunder && viewFunder.phone !=null">{{ viewFunder.phone }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.primary_currency') }}</label>
          <p v-if="viewFunder && viewFunder.currency !=null">{{ viewFunder.currency.code }}-{{ viewFunder.currency.name }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.website') }}</label>
          <p v-if="viewFunder && viewFunder.website !=null">{{ viewFunder.website }}</p>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('funder', [
      'viewFunder'
    ])
  },
  created () {},
  validations: {},
  mounted () {
  },
  methods: {}
}
</script>
